
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import {Prop, PropSync} from 'vue-property-decorator';
  import {TaskModel} from '@/models/task.model';
  import TaskCard from '@/components/Challenges/tabs/tasks/TaskCard.vue';

  @Component({
    components: {TaskCard}
  })
  export default class TaskDialog extends Vue {
    @Prop({required: true}) task!: TaskModel;
    @Prop({required: true}) canInteract!: boolean;
    @PropSync('openDialog', {required: true}) open!: boolean;
  }
